enum WhoRewardedVisibility {
  NO_REWARD = "NO_REWARD",
  LIMITED_OLD_REWARD = "LIMITED_OLD_REWARD",
  LIMITED_NEW_REWARD = "LIMITED_NEW_REWARD",
  LIMITED_CUSTOM_REWARD = "LIMITED_CUSTOM_REWARD",
  OLD_REWARD = "OLD_REWARD",
  NEW_REWARD = "NEW_REWARD",
  CUSTOM_REWARD = "CUSTOM_REWARD"
}

export default WhoRewardedVisibility
